import angular from 'angular';
import { EtiquetaComponent } from './etiqueta/etiqueta.component';
import { AppHeaderComponent } from './header/header.component';
import { OrderActionsComponent } from './order-actions/order-actions.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';

export const ComponentsModule = 'mandaeApp.components';

angular.module(ComponentsModule, [ 'LocalStorageModule', 'ngMaterial' ])
  .component('appEtiqueta', EtiquetaComponent)
  .component('appHeader', AppHeaderComponent)
  .component('appOrderActions', OrderActionsComponent)
  .component('appProgressBar', ProgressBarComponent)
